import api from "@/api/viktor"

//-- Check for feature flags
export async function getFeatureFlags(
  feature_name: string,
  scope: string = "api"
) {
  const response = await api({
    method: "GET",
    url: `/feature-flag/${feature_name}?scope=${scope}`,
  })
  return response
}
